import { ValueOf } from '@/types/util';

export const EChargeMethod = {
  STORE: '店頭',
  BANK_ACCOUNT: '銀行口座',
  CREDIT_CARD: 'クレジットカード',
} as const;

export type ChargeMethodKey = keyof typeof EChargeMethod;
export type ChargeMethodValue = ValueOf<typeof EChargeMethod>;

export const chargeMethodKeys = Object.keys(EChargeMethod) as ChargeMethodKey[];

/** v-select用items */
export const chargeMethodItems = chargeMethodKeys
  .map((key) => ({
    title: EChargeMethod[key],
    value: key,
  }));
